<template>
  <div class="page-container">
    <div class="register-wrapper">
      <div class="regitster-logo-wrap flex">
        <img src="../assets/image/cl_register_logo.png" alt />
      </div>
      <div class="regitster-form-wrap" v-show="registerStep.first">
        <div class="register-text">新用户注册</div>
        <div class="register-form-container">
          <el-form
            :model="registForm"
            :disabled="forbitRegist"
            :rules="registRules"
            ref="registForm"
            label-width="100px"
            class="account-login-form"
          >
            <el-form-item label="网名" prop="name" class="regist-form-item">
              <el-input
                type="text"
                v-model="registForm.name"
                placeholder="输入网名"
              ></el-input>
            </el-form-item>
            <div class="regist-address-container flex">
              <el-form-item label="出生地" prop="province">
                <el-select
                  v-model="registForm.province"
                  @change="changeProvince"
                  placeholder="请选择省份"
                >
                  <el-option
                    v-for="(item, index) in provinceArr"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="city">
                <el-select
                  v-model="registForm.city"
                  @change="changeCity"
                  placeholder="请选择城市"
                >
                  <el-option
                    v-for="(item, index) in cityArr"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="county">
                <el-select v-model="registForm.county" placeholder="请选择区县">
                  <el-option
                    v-for="(item, index) in countyArr"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <p class="address-tip">请如实填写，出生地与传联号相关</p>
            <el-form-item label="手机号" prop="mobile" class="regist-form-item">
              <el-input
                ref="userMobile"
                type="text"
                v-model="registForm.mobile"
                placeholder="输入手机号"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="短信验证码"
              prop="code"
              class="regist-form-item"
            >
              <div class="sefety-item-input flex">
                <el-input
                  v-model="registForm.code"
                  placeholder="输入验证码"
                ></el-input>
                <el-button
                  :disabled="banGetCode"
                  class="get-code-btn"
                  @click="getCode"
                  >{{ getCodeText }}</el-button
                >
              </div>
            </el-form-item>
            <el-form-item
              label="好友推广码"
              prop="recommendUser"
              class="regist-form-item"
            >
              <el-input
                type="text"
                v-model="registForm.recommendUser"
                placeholder="如果没有，不用填写"
              ></el-input>
            </el-form-item>
            <el-form-item class="agreement-wrap" prop="isagree">
              <el-checkbox v-model="registForm.isagree">同意</el-checkbox>
              <a class="agreement-link" @click="openUserDeal"
                >传联帐号使用协议</a
              >及
              <a @click="openPrivacyDeal" class="agreement-link">隐私协议</a>
            </el-form-item>
            <el-form-item class="submit-item">
              <el-button
                type="primary"
                class="handlian-btn"
                @click="submitForm('registForm')"
                >下一步</el-button
              >
              <el-button class="handlian-btn" @click="resetForm('registForm')"
                >重置</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="password-form-wrap" v-show="registerStep.second">
        <div class="password-form-container">
          <el-form
            :model="passwordForm"
            :disabled="forbitSetPsw"
            :rules="passwordRules"
            ref="passwordForm"
            label-width="120px"
            class="account-login-form"
          >
            <el-form-item label="获得传联号" class="regist-form-item">
              <el-input
                type="text"
                :disabled="true"
                v-model="passwordForm.handLianNum"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="设置新密码"
              prop="password"
              class="regist-form-item"
            >
              <el-input
                show-password
                v-model="passwordForm.password"
                placeholder="6-20个字符（最好不是纯数字）"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="确 认 密 码"
              prop="confirmPsw"
              class="regist-form-item"
            >
              <el-input
                show-password
                v-model="passwordForm.confirmPsw"
                placeholder="再次输入新密码"
              ></el-input>
            </el-form-item>
            <el-form-item class="submit-item">
              <el-button
                type="primary"
                class="handlian-btn"
                @click="submitForm('passwordForm')"
                >确定</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="use-agreement-wrap">
        <el-dialog
          title="传联帐号使用协议"
          :visible.sync="useDealVisible"
          :destroy-on-close="true"
          custom-class="handlian-agreement-dialog"
          width="1000px"
        >
          <div class="use-agreement-container">
            <p
              class="agreement-indent"
              v-for="(item, index) in userAgrement.title"
              :key="index"
            >
              {{ item }}
            </p>
            <div v-for="(item, index) in userAgrement.content" :key="index">
              <p>{{ item.subTitle }}</p>
              <div
                class="sub-content"
                v-for="(subItem, index) in item.subContent"
                :key="index"
              >
                <p class="sub-title">{{ subItem.title }}</p>
                <div
                  v-for="(childItem, index) in subItem.contenList"
                  :key="index"
                >
                  <p>{{ childItem }}</p>
                </div>
              </div>
            </div>
            <div class="inscribe-wrap">
              <p>{{ userAgrement.inscribe.name }}</p>
              <p>{{ userAgrement.inscribe.date }}</p>
            </div>
          </div>
        </el-dialog>
      </div>
      <div class="use-agreement-wrap">
        <el-dialog
          title="隐私政策"
          :visible.sync="usePrivacyVisible"
          :destroy-on-close="true"
          custom-class="handlian-agreement-dialog"
          width="1000px"
        >
          <iframe
            src="http://wechat.handlian.com/privacyProtocol.html"
            width="1000"
            height="600"
            name="privacyProtocol"
            scrolling="auto"
          ></iframe>
          <!-- <div class="use-agreement-container">
            <p class="greement-title">{{ privacyAgrement.agreeMentTitle }}</p>
            <p
              class="agreement-indent"
              v-for="(item, index) in privacyAgrement.title"
              :key="index"
            >
              {{ item }}
            </p>
            <div v-for="(item, index) in privacyAgrement.content" :key="index">
              <p class="blod-title blod-sub-title">{{ item.subTitle }}</p>
              <p class="indent-text">{{ item.contentSketch }}</p>
              <div
                class="sub-content p-item-content"
                v-for="(subItem, index) in item.subContent"
                :key="index"
              >
                <p class="sub-title">{{ subItem.title }}</p>
                <p class="indent-text">{{ subItem.subSketch }}</p>
                <div
                  v-for="(childItem, index) in subItem.contenList"
                  :key="index"
                >
                  <p>{{ childItem }}</p>
                </div>
                <div v-if="subItem.spcialTip" class="indent-text">
                  <span class="blod-title">{{
                    subItem.spcialTip.blodTitle
                  }}</span>
                  <span>{{ subItem.spcialTip.contenItem }}</span>
                </div>
                <div v-if="subItem.sdkListLink">
                  <a @click="sdkListClick()" class="sdk-list-link">{{
                    subItem.sdkListLink.text
                  }}</a>
                </div>
                <div v-if="subItem.checkReply" class="indent-text">
                  {{ subItem.checkReply }}
                </div>
                <div v-if="subItem.protocolDate" class="protocol-date">
                  {{ subItem.protocolDate }}
                </div>
              </div>
            </div>
          </div> -->
        </el-dialog>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Footer from "../components/Footer";
import { apiMap } from "../utils/apiMap";
export default {
  name: "register",
  data() {
    var validateUserName = (rule, value, callback) => {
      var nameRegExp = /^[a-zA-Z0-9_\u4e00-\u9fa5]{2,12}$/;
      var numberRegExp = /[^\d]/g;
      var lowerUserName = value.toLowerCase();
      let forbitName = ["传联", "官方", "客服", "chuanlian", "handlian"];
      var checkName = false;
      forbitName.forEach(function(item) {
        if (lowerUserName.indexOf(item) !== -1) {
          checkName = true;
        }
      });
      if (value === "") {
        callback(new Error("请输入网名"));
      } else if (!nameRegExp.test(value) || !numberRegExp.test(value)) {
        callback(
          new Error(
            "网名2-12个字符，支持中文、英文、数字，不允许纯数字、特殊字符、空格"
          )
        );
      } else if (checkName) {
        callback(new Error("网名含有限制词汇，请更换！"));
      } else {
        callback();
      }
    };
    var validateMobile = (rule, value, callback) => {
      var mobileRegExp = /^1[345789]\d{9}$/;
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!mobileRegExp.test(value)) {
        callback(new Error("手机号格式不正确"));
      } else {
        callback();
      }
    };
    var validateCode = (rule, value, callback) => {
      var numberRegExp = /^[0-9]+$/;
      if (value === "") {
        callback(new Error("请输入验证码"));
      } else if (!numberRegExp.test(value)) {
        callback(new Error("请输入数字验证码"));
      } else {
        callback();
      }
    };
    var validateSpreadCode = (rule, value, callback) => {
      var mixtureRegExp = /^[A-Za-z0-9]+$/;
      if (value !== "" && !mixtureRegExp.test(value)) {
        callback(new Error("推广码格式错误：应该由数组和字母组成"));
      } else {
        callback();
      }
    };
    var valitateProvince = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择省份"));
      } else {
        callback();
      }
    };
    var valitateCity = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择城市"));
      } else {
        callback();
      }
    };
    var valitateCounty = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择区县"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.passwordForm.password) {
        callback(new Error("两次输入密码不一致"));
      } else {
        callback();
      }
    };
    return {
      forbitRegist: false,
      forbitSetPsw: false,
      banGetCode: false,
      useDealVisible: false,
      usePrivacyVisible: false,
      registerStep: {
        first: true,
        second: false,
      },
      registToken: "",
      provinceArr: [{ id: "", name: "—— 省 ——" }],
      cityArr: [{ id: "", name: "—— 市 ——" }],
      countyArr: [{ id: "", name: "—— 县 ——" }],
      registForm: {
        name: "",
        province: "",
        city: "",
        county: "",
        mobile: "",
        code: "",
        isagree: "",
        recommendUser: "",
      },
      registRules: {
        name: [{ validator: validateUserName, trigger: "blur" }],
        province: [{ validator: valitateProvince, trigger: "change" }],
        city: [{ validator: valitateCity, trigger: "change" }],
        county: [{ validator: valitateCounty, trigger: "change" }],
        mobile: [{ validator: validateMobile, trigger: "blur" }],
        code: [{ validator: validateCode, trigger: "blur" }],
        isagree: [
          {
            required: true,
            message: "请阅读并同意注册注册协议",
            trigger: "change",
          },
        ],
        recommendUser: [{ validator: validateSpreadCode, trigger: "blur" }],
      },
      passwordForm: {
        handLianNum: "",
        password: "",
        confirmPsw: "",
      },
      passwordRules: {
        password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "长度在 6 到 20 个字符",
            trigger: "blur",
          },
        ],
        confirmPsw: [{ validator: validatePass, trigger: "blur" }],
      },
      getCodeText: "发送短信",
      banGetCode: false,
      timer: null,
      userAgrement: {
        title: [
          "贵州传联网络科技有限公司（以下简称传联），在遵守国家相关法律的前提下，为了使需要传联服务的人得到最好的体验，特与您约定以下条款。如果您注册或使用传联的相关服务，则视为已经阅读并已经充分理解《传联帐号使用协议》（以下简称本协议）。",
          "如果您因年龄、智力等因素而不具有完全民事行为能力，请在法定监护人的陪同下阅读和判断是否同意本协议。",
        ],
        content: [
          {
            subTitle: "一【传联帐号的性质】",
            subContent: [
              {
                title:
                  "1.1 传联号码是传联按照本协议授权注册用户用于登录、使用传联的软件或服务的数字标识，其所有权属于传联。",
                contenList: [],
              },
            ],
          },
          {
            subTitle: "二【传联号码的获取】",
            subContent: [
              {
                title:
                  "2.1 您可以通过如下方式免费或有偿申请注册传联号码，包括但不限于（具体方式以传联官方实际提供为准）：",
                contenList: [
                  "（1）软件客户端；",
                  "（2）传联网站；",
                  "（3）手机短信；",
                  "（4）其他传联授权的方式。",
                  "（5）为了保证信息的准确传承，每个人只允许申请一个传联号，如果您使用了两个传联号，可能会导致身份信息的混乱，请您务必知晓。",
                ],
              },
              {
                title:
                  "2.2 您完成申请注册程序后，传联按照本协议授权您登录、使用传联的软件或服务，依照传联的业务规则使用该帐号。",
                contenList: [],
              },
              {
                title:
                  "2.3 任何主体通过任何方式使用传联帐号的，均受本协议约束。",
                contenList: [],
              },
              {
                title:
                  "2.4 为改善用户体验和（或）提供技术便利，传联服务的帐号可能包括数字、字母或者其组合，以及手机号码、电子信箱等多种形式。在您注册某一形式的帐号时，传联可能附赠该帐号的另一表现形式。具体的帐号形式、帐号体系及帐号之间的关联关系等，以传联实际提供的为准。",
                contenList: [],
              },
            ],
          },
          {
            subTitle: "三【用户身份信息验证】",
            subContent: [
              {
                title:
                  "3.1 您在申请传联帐号过程中，需要填写一些必要真实的信息，以便传联向您提供帮助，或更好地为您提供服务，否则可能无法使用服务或在使用过程中受到限制。",
                contenList: [],
              },
              {
                title:
                  "3.2 传联与您一同致力于个人隐私的保护，保护信息安全是传联的基本使命。未经您的同意，传联不会向第三方披露您的个人信息，但法律法规另有规定的除外。",
                contenList: [],
              },
              {
                title:
                  "3.3 关于传联如何收集、使用、储存和分享您的个人信息，还请注意阅读使用过程中的相应规则。",
                contenList: [],
              },
            ],
          },
          {
            subTitle: "四【传联帐号的安全】",
            subContent: [
              {
                title:
                  "4.1 传联密码由您自行设定。您应妥善保管您的传联帐号及密码，并对此传联号码和密码实施的所有活动及其后果承担责任。",
                contenList: [],
              },
              {
                title:
                  "4.2 传联与您共同负有维护传联帐号安全的责任。传联会采取并不断更新技术措施，努力保护您的传联帐号在服务器端的安全。",
                contenList: [],
              },
              {
                title:
                  "4.3 您须采取必要措施保护您的帐号安全，包括但不限于妥善保管传联帐号与密码，安装防病毒、木马软件，定期更改密码等措施。",
                contenList: [],
              },
              {
                title:
                  "4.4 除前述各条款约定外，用户还须妥善保管与传联帐号及密码相关的任何数字证书、手机动态口令或验证码、账户绑定的手机号码等一切信息和设备。如您更换、暂停或终止使用上述信息和（或）设备，或遗失或泄露前述信息和（或）设备的，应及时采取必要措施，以减少可能发生的损失，因上述原因所致损失需由您本人承担。",
                contenList: [],
              },
              {
                title:
                  "4.5 若您的传联帐号被盗，请及时跟我们联系， 技术员会尽其所能提供服务，但不保证可以找回。",
                contenList: [],
              },
              {
                title:
                  "4.6 您有义务遵守国家相关法律的同时，不得恶意注册、获取传联帐号。一经发现，将立即限制或终止对您的所有服务，由此造成的损失（包括第三方）您全部承担。",
                contenList: [],
              },
              {
                title:
                  "4.7 若因传联原因导致您的帐号被盗或数据丢失，传联愿意赔偿由此造成的损失（见相关协议）。",
                contenList: [],
              },
            ],
          },
          {
            subTitle: "五【帐号安全保护】",
            subContent: [
              {
                title:
                  "5.1 为了保护您的传联帐号的安全，使您可以更加安全地使用本服务，传联可能会不断升级、完善我们的安全技术防护措施，若传联根据自己的判断认为您的帐号可能存在被盗号等风险时，为了保护您的账户安全、财产免受损失等，可能会采取向您发出一定的提示、暂时冻结您对帐号的使用等措施。您应该按照传联的提示或指引进行操作，以降低您帐号被盗的风险，以便恢复您对帐号的使用。",
                contenList: [],
              },
              {
                title:
                  "5.2 传联可能会升级相关功能或对服务内容及软件进行修改，恕不另外通知，请您关注传联的相关申明。",
                contenList: [],
              },
            ],
          },
          {
            subTitle: "六【信息安全】",
            subContent: [
              {
                title:
                  "6.1 您一旦成功申请传联号，将拥有一定的普通存储空间，升星级后可以获得相应的永久存储空间，需要永久存储的文章、相片、视频或音频，您务必勾选，否则如果该传联号6个月不活动，或者被讣告，我们将清空非永久存储的内容，且无法恢复，由此造成的后果，您自己承担。",
                contenList: [],
              },
              {
                title:
                  "6.2 如果亲人不幸离世，务必发出讣告，否则亲人的手机号码如果易主，亲人的信息就可能泄露。",
                contenList: [],
              },
            ],
          },
          {
            subTitle: "七【船票与空间】",
            subContent: [
              {
                title:
                  "7.1 船票可以用于升级获得永久存储空间，也可以购买短期存储空间。船票的获得方式有多种，请您注意相关提示。",
                contenList: [],
              },
              {
                title: "7.2 空间一旦获得，不再提供退回服务。",
                contenList: [],
              },
            ],
          },
          {
            subTitle: "八【更多】",
            subContent: [
              {
                title:
                  "软件中的相关说明，也作为本协议不可分割的部分，请注意阅读。",
                contenList: [],
              },
              {
                title: "（正文完）",
                contenList: [],
              },
            ],
          },
        ],
        inscribe: {
          name: "贵州传联网络科技有限公司",
          date: "2019年12月",
        },
      },
      privacyAgrement: {
        agreeMentTitle: "传联《隐私政策》",
        title: [
          "贵州传联网络科技有限公司及其关联方（以下简称“我们”）作为传联的运营者，深知个人信息对你的重要性，我们将依法依规，保护你的个人信息及隐私安全，希望你在使用传联及相关服务前仔细阅读并理解本《隐私政策》，以便做出适当的选择。",
          "当你使用或开启相关功能或使用服务时，为实现功能、服务所必需，我们会收集、使用相关信息，除非是为实现基本业务功能或根据法律法规要求所必需的必要信息，你均可以拒绝提供且不影响其他功能或服务。我们将在《隐私政策》中逐项说明哪些是必要信息。",
          "如果你未登录帐号，我们会通过设备对应的标识符信息来保障信息推送的基本功能。如果你登录了帐号，我们会根据帐号信息实现信息推送。",
          "为了方便你拨打我们的服务电话，或者应用内的其它商家电话，可能会申请通讯录权限。",
          "通讯录、精确地理位置、摄像头、麦克风、相册权限，均不会默认开启，只有经过你的授权才会在为实现特定功能或服务时使用，你也可以撤回授权，特别需要指出的是，为了方便使用，我们只征求授权一次，在相关功能或服务不需要时，我们不会多余收集你的信息。",
          "下面是我们如何收集、使用、存储、传输、分享与保护个人信息,并帮你了解如何查询、访问、删除、更正、撤回授权个人信息的方式。",
        ],
        explianSubTitle: [
          "本《隐私政策》适用于你通过传联APP、传联官方网站、供第三方网站和应用程序使用的传联软件开发工具包（SDK）和应用程序编程接口（API）方式来访问和使用我们的产品和服务。",
          "现在，我们将详细告知你：我们如何收集、使用、存储、传输、分享与保护个人信息；帮你了解查询、访问、删除、更正、撤回授权个人信息的方式。",
        ],
        content: [
          {
            subTitle: "1.我们如何收集和使用个人信息",
            contentSketch:
              "我们会按照如下方式收集你在使用服务时主动提供的，以及通过自动化手段收集你在使用功能或接受服务过程中产生的信息：",
            subContent: [
              {
                title: "1.1 注册、登录、认证",
                subSketch: "",
                contenList: [],
              },
              {
                title: "1.1.1 注册、登录帐号",
                subSketch:
                  "当你注册、登录传联及相关服务时，你可以通过手机号及出生地创建传联号，并完善相关的网络身份识别信息（网名、密码），收集这些信息是为了帮助你完成注册。登录后，你还可以根据自身需求选择完善头像、性别、生日、乳名、常驻地及个人简介等信息，这些信息将通过家谱向你的后代展示。",
                contenList: [],
              },
              {
                title: "1.1.2 认证",
                subSketch:
                  "使用家谱功能时，鉴于家谱的特殊性，须完成实名认证（真实姓名、身份证号码）后方可操作。 身份信息属于个人敏感信息，你可以拒绝提供，如果拒绝提供你将可能无法获得该项服务，但不影响其他功能与服务的正常使用。",
                contenList: [],
              },
              {
                title: "1.2 播放浏览",
                subSketch:
                  "你可以播放浏览小区、社区、族窗中，其他网友分享的内容。为保障推荐内容的质量并向你推荐可能感兴趣的作品，传联可能会收集相关必要的日志信息。上述日志信息包括：",
                contenList: [
                  "(1)你操作、使用的行为信息：点击关注、收藏、搜索、浏览、分享",
                  "(2)你主动提供的信息：反馈、发布、点赞、评论",
                ],
              },
              {
                title: "1.3 发布与互动",
                subSketch: "",
                contenList: [],
              },
              {
                title: "1.3.1 信息发布",
                subSketch: "",
                contenList: [
                  "a.你发布相册、文章等内容或进行评论时，我们将收集你发布的信息，并在你所分享的范围（社区/小区/族窗）展示昵称、头像、网名及发布内容。",
                  "b.你使用上传图片、音视频功能时，我们会请求你授权相机、相册、麦克风权限。你如果拒绝授权提供，将无法使用此功能，但不影响你正常使用传联的其他功能。",
                  "c.你使用“实体店”及相关服务时，我们会请求你授权精确地理位置权限，帮助你估算商家与你之间的距离以便于你进行消费决策，或为你推荐附近的服务品类和优惠信息等。你如果拒绝授权提供精确地理位置信息，将无法使用此功能，但不影响你正常使用传联的其他功能。",
                  "d.当你选择文章或相册分享时，我们会对你的作品进行合规审核，审核通过即刻为你分享。我们尊重你的权利，如果你想撤回分享，可以在【我的】-【文章（相册）】-【相应作品】-【下拉按钮】-【撤回分享】。",
                  "e.你的文章、相册、音视频，只要选择永久保存，后代即通过家谱看到你的作品，如果你不想让后代看到，请不要选择永久保存，已经永久保存的，取消永久保存即可。",
                ],
              },
              {
                title: "1.3.2 互动交流",
                subSketch: "",
                contenList: [
                  "a.为了你获得更好的体验，当你关注某帐号，或进行浏览、评论、收藏、搜索、点赞时，我们会收集你前述信息，以便此为依据，向你推荐你感兴趣的作品或作者。",
                  "b.你可以在传联中添加或删除朋友，为帮你实现这一功能，我们会创建朋友列表信息。朋友列表是建立与管理朋友关系所必需的必要信息。",
                  "c.当你使用群功能时，我们会创建群聊列表及相关信息。",
                  "d.当你选择使用扫码添加朋友时，传联可能会向你请求摄像头权限，摄像头权限是敏感权限，拒绝提供仅会使你无法通过扫码途径添加朋友，不影响其他功能的使用。",
                  "e.当你使用传联进行私信时，我们会根据国家相关要求，对你们之间的私信内容进行保存，我们非常尊重你的隐私，未经法律允可，不会向任何第三方提供你们的私信内容。",
                ],
              },
              {
                title: "1.3.3 朋友推荐",
                subSketch:
                  "传联可能会根据你所在地区，向你推荐好友。同时，你也会被推荐给其他网友，推荐时你的网名、头像、传联号会向网友展示。",
                contenList: [],
              },
              {
                title: "1.3.4 推送通知",
                subSketch:
                  "你知悉并同意，我们在运营中可能会向你发送多类通知，比如:用户消息、身份验证、传连通知等。如果你不喜欢，可以随时通过手机设置进行关闭。",
                contenList: [],
              },
              {
                title: "1.4 搜索",
                subSketch:
                  "用传联的搜索服务时，我们会收集你的搜索关键字信息、日志记录。为了提供高效的搜索服务，部分前述信息会暂时存储在你的本地存储设备之中，并可向你展示搜索结果内容、搜索历史记录。",
                contenList: [],
              },
              {
                title: "1.5 运营与安全运行",
                subSketch: "",
                contenList: [],
              },
              {
                title: "1.5.1 运营与安全保障",
                subSketch:
                  "我们致力于为你提供安全、可信的平台与使用环境，提供优质而可靠的服务与信息是我们的核心目标。",
                contenList: [],
              },
              {
                title: "1.5.2 设备信息与日志信息",
                subSketch: "",
                contenList: [
                  "a.为了保障软件与服务的安全运行、运营的质量及效率，我们会收集必要的硬件和软件信息、如手机型号、操作系统版本号、国际移动设备识别码、唯一设备标识符、网络设备硬件地址、IP 地址、软件版本号及操作、使用、服务日志。",
                  "b.为了预防恶意程序、保障运营质量及效率，我们会收集安装的应用信息或正在运行的进程信息、应用程序的总体运行、使用情况与频率、应用崩溃情况、总体安装使用情况、性能数据、应用来源。",
                  "c.我们可能使用你的账户、设备、日志等信息用于判断账户安全、进行身份验证、检测及防范安全事件。",
                ],
              },
              {
                title: "1.6 分享与活动参与",
                subSketch:
                  "在你分享作品、参加活动等情形下，我们需要访问你的剪切板，读取其中包含的口令、分享码、链接，以实现跳转。",
                contenList: [],
              },
              {
                title: "1.7 收集、使用个人信息目的之变更",
                subSketch:
                  "请你注意，随着我们业务的发展，可能会对传联的功能和提供的服务有所调整。原则上，当新功能或服务与我们当前提供的功能或服务相关时，收集与使用的个人信息将与原处理目的具有直接或合理关联。在与原处理目的无直接或合理关联的场景下，我们收集、使用你的个人信息，会再次进行告知，并征得你的同意。",
                contenList: [],
              },
              {
                title: "1.8 依法豁免征得同意收集和使用的个人信息",
                subSketch:
                  "请你理解，在下列情形中，根据法律法规及相关国家标准，我们收集和使用你的个人信息无需征得你的授权同意：",
                contenList: [
                  "a.与国家安全、国防安全直接相关的；",
                  "b.与公共安全、公共卫生、重大公共利益直接相关的；",
                  "c.与犯罪侦查、起诉、审判和判决执行等直接相关的；",
                  "d.出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；",
                  "e.所收集的你的个人信息仅是你自行向社会公众公开的；",
                  "f.从合法公开披露的信息中收集的你的个人信息的，如合法的新闻报道、政府信息公开等渠道；",
                  "g.根据你的要求签订或履行合同所必需的；",
                  "h.用于维护软件及相关服务的安全稳定运行所必需的，例如发现、处置软件及相关服务的故障；",
                  "i.为合法的信息所必需的；",
                  "j.学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；",
                  "k.法律法规规定的其他情形。",
                ],
                spcialTip: {
                  blodTitle: "特别提示你注意，",
                  contenItem:
                    "如信息无法单独或结合其他信息识别到你的个人身份，其不属于法律意义上你的个人信息；当你的信息可以单独或结合其他信息识别到你的个人身份时或我们将无法与任何特定个人信息建立联系的数据与其他你的个人信息结合使用时，这些信息在结合使用期间，将作为你的个人信息按照本《隐私政策》处理与保护。",
                },
              },
            ],
          },
          {
            subTitle: "2.我们如何使用Cookie等同类技术",
            contentSketch:
              "Cookie 和设备信息标识等同类技术是互联网中普遍使用的技术。当你使用传联及相关服务时，我们可能会使用相关技术向你的设备发送一个或多个Cookie 或匿名标识符，以收集、标识你访问、使用本产品时的信息。我们承诺，不会将Cookie 用于本《隐私政策》所述目的之外的任何其他用途。我们使用Cookie 和同类技术主要为了实现以下功能或服务：",
            subContent: [
              {
                title: "2.1 保障产品与服务的安全、高效运行",
                subSketch:
                  "我们可能会设置认证与保障安全性的Cookie 或匿名标识符，使我们确认你是否安全登录服务，或者是否遇到盗用、欺诈及其它不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。",
                contenList: [],
              },
              {
                title: "2.2 帮助你获得更轻松的访问体验",
                subSketch:
                  "使用此类技术可以帮助你省去重复填写你个人信息、输入搜索内容的步骤和流程。",
                contenList: [],
              },
              {
                title: "2.3 为你推荐、展示、推送你可能感兴趣的作品或作",
                subSketch: "",
                contenList: [
                  "a.我们可能会利用此类技术了解你的偏好和使用习惯，进行数据分析，以改善产品服务、推荐你感兴趣的信息或功能。",
                  "b.在你使用传联分享作品过程中，我们可能会使用Cookie对浏览活动进行记录，用于向你推荐信息和排查崩溃、延迟的相关异常情况以及获得更好的服务方式。",
                ],
              },
              {
                title: "2.4 Cookie的清除",
                subSketch:
                  "大多数浏览器均为用户提供了清除浏览器缓存数据的功能，你可以在浏览器设置功能中进行相应的数据清除操作。如你进行清除，你可能无法使用由我们提供的、依赖于Cookie的服务或相应功能。",
                contenList: [],
              },
            ],
          },
          // {
          //     subTitle: "2.我们如何使用Cookie等同类技术",
          //     contentSketch: "",
          //     subContent: [
          //         {
          //             title: "2.4 Cookie的清除",
          //             subSketch: "",
          //             contenList: []
          //         },
          //     ]
          // },
          {
            subTitle: "3.我们如何分享、转让、公开披露个人信息",
            contentSketch: "",
            subContent: [
              {
                title: "3.1分享",
                subSketch: "",
                contenList: [],
              },
              {
                title: "3.1.1 分享原则",
                subSketch: "",
                contenList: [
                  "a.授权同意原则：未经你的同意，我们不会分享你的个人信息，除非分享的个人信息是去标识化处理后的信息，且分享第三方无法重新识别此类信息的自然人主体。如果第三方使用信息的目的超越原授权同意范围，他们需要重新征得你的同意。",
                  "b.合法正当与最小必要原则： 分享的数据必须具有合法正当目的，且分享的数据以达成目的为限。",
                  "c.安全审慎原则： 我们将审慎评估第三方使用分享信息的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循合作法律协议。我们会对合作方获取信息的软件工具开发包（SDK）、应用程序接口（API）进行严格的安全监测，以保护数据安全。",
                ],
                sdkListLink: {
                  text: "传联APP接入第三方SDK情况",
                  link: "",
                },
              },
              {
                title: "3.1.2 实现功能或服务的分享信息",
                subSketch: "",
                contenList: [
                  "a.当你在使用传联中由我们的关联方、第三方提供的功能，或者当软件服务提供商、智能设备提供商、系统服务提供商与我们联合为你提供服务时我们会将实现业务所必需的信息与这些关联方、第三方分享，用于综合统计并通过算法做特征与偏好分析，用以向你推荐、展示或推送你可能感兴趣的信息，或者推送更适合你的特定功能或服务。",
                  "b.当你选择发布信息到关联方或第三方的产品或服务（如微信等）后，传联可能会使用SDK或相关技术与这些产品或服务的提供方分享发布的内容。",
                  "c.地理位置服务：当你使用地理位置相关服务时，我们会通过SDK或相关技术将GPS信息与位置服务提供商（高德地图）进行分享以便可以向你返回位置结果。GPS信息是个人敏感信息，拒绝提供，仅会影响地理位置服务功能，但不影响其他功能的正常使用。",
                  "d.钱包功能：钱包功能中的相关服务由我们的关联方及合作伙伴提供，当你使用钱包相关功能时我们的关联方和合作伙伴会根据功能或服务必需而收集必要限度内的信息。",
                  "e.充值功能：充值功能由与我们合作的第三方支付机构向你提供服务。第三方支付机构可能需要收集你的姓名、银行卡类型及卡号、有效期及手机号码。银行卡号、有效期及手机号码 是个人敏感信息，这些信息是支付功能所必需的信息，拒绝提供将导致你无法使用该功能，但不影响其他功能的正常使用。",
                  "f.为与你使用的终端机型适配消息推送功能，我们可能会通过SDK等技术与终端设备制造商（华为、小米、OPPO、VIVO等）分享手机型号、版本及相关设备信息。",
                ],
              },
              {
                title: "3.1.3 实现安全与分析统计的分享信息",
                subSketch: "",
                contenList: [
                  "a.保障使用安全：我们非常重视帐号、服务及内容安全，为保障你和其他用户的帐号与财产安全，使你和我们的正当合法权益免受不法侵害，我们和关联方或服务提供商可能会分享必要的设备、帐号及日志信息。",
                  "b.分析产品使用情况：为分析我们服务的使用情况，提升你的使用体验，可能会与关联方或第三方分享产品使用情况（崩溃、闪退）的统计性数据，这些数据难以与其他信息结合识别你的个人身份。",
                  "c.学术研究与科研：为提升相关领域的科研能力，促进科技发展水平，我们在确保数据安全与目的正当的前提下，可能会与科研机构分享去标识化或匿名化的数据。",
                ],
              },
              {
                title: "3.2 转让",
                subSketch: "",
                contenList: [
                  "a.我们不会转让你的个人信息给任何其他第三方，除非征得你的明确同意。",
                  "b.随着我们业务的发展，我们将有可能进行合并、收购、资产转让，你的个人信息有可能因此而被转移。在发生前述变更时，我们将按照法律法规及不低于本《隐私政策》所载明的安全标准要求继受方保护你的个人信息，否则我们将要求继受方重新征得你的授权同意。",
                ],
              },
              {
                title: "3.3 公开展示",
                subSketch: "",
                contenList: [
                  "a. 我们不会公开披露你的信息，除非遵循国家法律法规的相关规定或者获得你的同意。我们公开披露你的个人信息会采用符合行业内标准的安全保护措施。",
                  "b. 对违规帐号、欺诈行为进行处罚公告时，我们会未经授权而披露相关帐号的信息。",
                  "c.你主动分享的作品、点赞、评论将会在小区（社区、族窗）中展示。小区，好友可以看到；社区，所有传联网友可以看到；族窗，你的族谱成员可以看到。",
                  "d.我们不主动分享你的作品给第三方合作伙伴，除非征得你同意，或你已主动分享至社区中。",
                ],
              },
              {
                title:
                  "3.4 依法豁免征得同意分享、转让、公开披露的个人信息请你理解，在下列情形中，根据法律法规及国家标准，我们分享、转让、公开披露你的个人信息无需征得你的授权同意：",
                subSketch: "",
                contenList: [
                  "a.与国家安全、国防安全直接相关的；",
                  "b.与公共安全、公共卫生、重大公共利益直接相关的；",
                  "c.与犯罪侦查、起诉、审判和判决执行等直接相关的；",
                  "d.出于维护你或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；",
                  "e.你自行向社会公众公开的个人信息；",
                  "f.从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。",
                ],
              },
            ],
          },
          {
            subTitle: "4.我们如何存储个人信息",
            contentSketch: "",
            subContent: [
              {
                title: "4.1 存储地点",
                subSketch:
                  "我们依法依规，收集你的个人信息，存储于中华人民共和国境内。目前，我们不会将传输至境外，如果我们向境外传输，将会遵循相关国家规定或者征得你的明确同意。",
                contenList: [],
              },
              {
                title: "4.2 存储期限",
                subSketch:
                  "我们仅在为提供服务之目的所必需的期间内保留你的个人信息：你发布的作品、评论、点赞及其它信息，在你未撤回、删除或未注销帐号期间，我们会保留相关信息。超出必要期限后，我们将对你的个人信息进行删除或匿名化处理，但法律法规另有规定的除外。",
                contenList: [],
              },
            ],
          },
          {
            subTitle: "5.我们如何保护个人信息的安全",
            contentSketch: "",
            subContent: [
              {
                title: "",
                subSketch: "",
                contenList: [
                  "a.我们非常重视你个人信息的安全，将努力采取合理的安全措施（包括技术方面和管理方面）来保护你的个人信息，防止你提供的个人信息被不法使用或在未经授权的情况下被访问、公开披露、使用、修改、损坏、丢失或泄漏。",
                  "b.我们会使用不低于行业同行的加密技术、匿名化处理及相关合理可行的手段保护你的个人信息，并使用安全保护机制防止你的个人信息遭到恶意攻击。",
                  "c.我们会建立有专门的技术部门、管理制度、数据流程制度，以保障你的个人信息安全。我们采取严格的数据使用和访问制度，确保只有授权人员才可访问你的个人信息，并适时对数据和技术进行安全审计。",
                  "d.尽管已经采取了上述合理有效措施，并已经遵守了相关法律法规的标准，但请你理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，不可能始终保证信息百分之百的安全，但我们会竭尽全力，确保你提供给我们的个人信息的安全性。",
                  "e.请你知悉并理解，你接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议你采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的帐号密码及相关个人信息透露给他人等。",
                  "f.我们会制定应急处理预案，并在发生用户信息安全事件时立即启动应急预案，努力阻止这些安全事件的扩大。一旦发生信息安全事件，我们将依法依规，及时将事件相关情况以推送通知、邮件、短信或其它形式告知你：安全事件的基本情况和可能的后果、我们已经采取或将要采取的处置措施、你可自主防范和降低风险的建议、对你的补救措施。难以逐一告知时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门的要求，上报安全事件的处置情况。",
                  "g.你一旦离开传联及相关服务，浏览或使用其他网站、服务及内容资源，我们将没有能力和直接义务保护你在传联及相关服务之外的软件、网站提交的任何个人信息，无论你登录、浏览或使用上述软件、网站是否基于传联的链接或引导。",
                ],
              },
            ],
          },
          {
            subTitle: "6.管理你的个人信息",
            contentSketch:
              "我们非常重视个人信息的管理，严格按照上述要求保护个人信息的查询、访问、修改、删除、撤回同意授权、注销帐号、投诉举报的相关权利，以保障你的隐私和信息安全。",
            subContent: [
              {
                title: "6.1 改变或撤回授权范围",
                subSketch: "",
                contenList: [],
              },
              {
                title: "6.1.1 改变或撤回敏感权限设置",
                subSketch: "",
                contenList: [
                  "a.你可以在设备本身操作系统中关闭精确地理位置信息、通讯录、摄像头、麦克风、相册权限，改变同意范围或撤回你的授权。撤回授权后我们将不再收集与这些权限相关信息。",
                ],
              },
              {
                title: "6.1.2 改变或撤回授权的信息处理",
                subSketch:
                  "特定的业务功能和服务需要你的得到必要个人信息才能获得，当你撤回授权后，我们无法继续为你提供撤回授权所对应的功能和服务，也不再处理你相应的个人信息。但你撤回授权的决定，不会影响的此前我们对个人信息的处理。",
                contenList: [],
              },
              {
                title: "6.2 访问、删除、更正你的个人信息",
                subSketch: "",
                contenList: [],
              },
              {
                title: "6.2.1 访问个人帐号信息",
                subSketch:
                  "你的头像、网名、简介、性别、生日、出生地、常驻地，可以在【我的】-【编辑资料】进行查询或更正。进入【我的】-【账户】-【实名认证】，可取消你的实名认证。",
                contenList: [],
              },
              {
                title: "6.2.2 作品的分享、访问、更正与删除",
                contenList: [
                  "a.进入【我的】-【文章】等-【相应作品】-【更多设置】中可访问、更正、删除或撤回你的分享。",
                  "b.进入【我的】-【关注】可以访问、查询关注的帐号信息，在关注列表点击相应帐号后可以选择取消关注该帐号。",
                  "c.进入【我的】-【设置】可更改绑定的手机号、更换传联密码。",
                ],
              },
              {
                title: "6.2.3 信息的分享范围",
                subSketch: "",
                contenList: [
                  "a.进入【我】-【文章】（【相册】）-【相应作品】-【更多设置】可以撤回分享，或更改分享范围。",
                  "b.你的基本信息，包括头像、网名、简介、性别、生日、出生地、乳名、常驻地，及你永久保存的作品，仅限子孙可以通过家谱查阅。",
                ],
              },
              {
                title: "6.3 注销帐号",
                subSketch:
                  "你可以在【我的】-【设置】-【帐号注销】进行注销帐号。在你注销帐号前，我们将验证你的个人身份、安全状态、设备信息等，请注意阅读《注销须知》。",
                contenList: [],
              },
              {
                title: "6.4 投诉举报",
                subSketch:
                  "如果你认为你的个人权利可能受到侵害，或者发现侵害个人权利的线索，你可以在【我的】-【设置】-【意见或建议】（或联系我们）向我们反馈，也可以选择电话或邮递方式，我们核查后会在15个工作日内反馈你的投诉与举报。",
                contenList: [],
              },
              {
                title: "6.5 访问《隐私政策》",
                subSketch: "",
                contenList: [
                  "a.你可以在注册页面，或者在登录个人帐号【我的】-【设置】- 【隐私政策】查看全部内容。",
                  "b.请你知悉，本《隐私政策》中所述的传联及相关服务可能会根据你所使用的手机型号、系统版本、软件应用程序版本、移动客户端等因素而有所不同。最终的产品和服务以你所使用的传联软件及相关服务为准。",
                ],
              },
              {
                title: "6.6 停止运营向你告知",
                subSketch:
                  "如我们停止运营，我们将及时停止收集你个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知你，并对你的个人信息进行删除或匿名化处理。",
                contenList: [],
              },
            ],
          },
          {
            subTitle: "7.未成年人条款",
            contentSketch:
              "我们致力于保护未成年人的权益，虽然传联的主要目的不是娱乐。",
            subContent: [
              {
                title: "",
                subSketch: "",
                contenList: [
                  "a.若你是未满18周岁的未成年人，在使用传联及相关服务前，应在你的监护人指导下共同阅读并同意本《隐私政策》。",
                  "b.我们只会在法律允许、监护人明确同意或保护未成年人采取必要施的前提下收集、使用、分享或披露未成年人的个人信息。",
                  "c.如果你发现监护对象的个人信息有相关疑问时，请通过本《隐私政策》公示的联系方式与我们联系。",
                ],
              },
            ],
          },
          {
            subTitle: "8.《隐私政策》的修订和通知",
            contentSketch:
              "随着业务的发展及国家相关法规的要求发生变更，我们会适时对传联的《隐私政策》进行修订，在使用传联时请你关注，登录后，通过【我的】-【设置】-【隐私政策】查看其全部内容。",
            subContent: [
              {
                title: "",
                subSketch: "",
                contenList: [],
              },
            ],
          },
          {
            subTitle: "9.联系我们",
            contentSketch: "",
            subContent: [
              {
                title: "",
                subSketch:
                  "如果你对个人信息保护问题有投诉、建议、疑问，欢迎与我们联系：",
                contenList: [
                  "地址：贵州省贵阳市花溪区林都国际三栋三单元401室",
                  "邮编：550025",
                  "电话：0851-88507279",
                ],
                checkReply: "我们将尽快审核所涉问题，并在十五个工作日内回复。",
                protocolDate: "2021年7月24日",
              },
            ],
          },
        ],
      },
    };
  },
  components: {
    Footer,
  },
  mounted() {
    this.initProvinceData();
  },
  methods: {
    submitForm(formName) {
      let _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          if (formName == "registForm") {
            let paramsArr = [
              `mobile=${_this.registForm.mobile}`,
              `scene=1`,
              `code=${_this.registForm.code}`,
            ];
            if (_this.registForm.recommendUser !== "") {
              paramArr.push(`recommendUser=${_this.registForm.recommendUser}`);
            }
            if (!_this.registForm.isagree) {
              _this.$alert("请阅读并同意传联帐号使用协议及隐私协议", {
                confirmButtonText: "确定",
                showClose: false,
              });
              return;
            }
            _this.checkSMScode(paramsArr, function(respond) {
              if (respond.statusCode == 1) {
                let paramArr = [
                  `name=${_this.registForm.name}`,
                  `birthPlaceProvinceId=${_this.registForm.province}`,
                  `birthPlaceCityId=${_this.registForm.city}`,
                  `birthPlaceCountryId=${_this.registForm.county}`,
                  `mobile=${_this.registForm.mobile}`,
                  `scene=1`,
                  `code=${_this.registForm.code}`,
                  `isagree=1`,
                ];
                if (_this.registForm.recommendUser !== "") {
                  paramArr.push(
                    `recommendUser=${_this.registForm.recommendUser}`
                  );
                }
                _this.registHandLian(paramArr);
              } else {
                _this.$alert(respond.data, {
                  confirmButtonText: "确定",
                  showClose: false,
                });
              }
            });
          } else {
            let paramArr = [
              `token=${_this.registToken}`,
              `password=${_this.passwordForm.password}`,
              `notpassword=${_this.passwordForm.confirmPsw}`,
            ];
            _this.setPassword(paramArr);
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    checkSMScode(paramArr, okCBK) {
      let _this = this;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["checkCode"]["method"],
          url: apiMap["checkCode"]["url"],
          data: paramArr.join("&"),
        })
        .then(function(response) {
          if (response.data.code == 200) {
            okCBK(response.data.result);
          }
        });
    },
    registHandLian(paramArr) {
      let _this = this;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["register"]["method"],
          url: apiMap["register"]["url"],
          data: paramArr.join("&"),
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.passwordForm.handLianNum = response.data.result.data.handNum;
            _this.registToken = response.data.result.data.token;
            _this.$message({
              message: "注册成功，请设置密码",
              type: "success",
              duration: 2000,
            });
            _this.registerStep = {
              first: false,
              second: true,
            };
          } else {
            _this.$alert(response.data.result.data, {
              confirmButtonText: "确定",
              showClose: false,
            });
          }
        });
    },
    getCode() {
      let _this = this;
      _this.$refs["registForm"].validateField("mobile", (error) => {
        if (!error) {
          let newMobile = _this.$refs.userMobile.value;
          if (newMobile) {
            _this.sendCode(function(respond) {
              if (respond.statusCode == 1) {
                _this.$notify({
                  title: "提示",
                  message: "验证码发送成功",
                  type: "success",
                });
                _this.countSecondDown();
              } else {
                _this.$alert(respond.data, {
                  confirmButtonText: "确定",
                  showClose: false,
                });
              }
            });
          }
        }
      });
    },
    sendCode(okCBK) {
      let _this = this;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["verifyCode"]["method"],
          url: apiMap["verifyCode"]["url"],
          data: `mobile=${this.$refs.userMobile.value}&scene=1`,
        })
        .then(function(response) {
          okCBK(response.data.result);
        });
    },
    countSecondDown() {
      const TIME_COUNT = 59;
      if (!this.timer) {
        var count = TIME_COUNT;
        this.banGetCode = true;
        this.timer = setInterval(() => {
          if (count > 0 && count <= TIME_COUNT) {
            this.getCodeText = `发送短信(${count--})`;
          } else {
            clearInterval(this.timer);
            this.timer = null;
            this.banGetCode = false;
            this.getCodeText = "发送短信";
          }
        }, 1000);
      }
    },
    initProvinceData() {
      let _this = this;
      _this.getCityData("", function(province) {
        province.forEach((item) => {
          _this.provinceArr.push(item);
        });
      });
    },
    changeProvince(provinceId) {
      let _this = this;
      if (provinceId !== "") {
        _this.registForm.city = "";
        _this.registForm.county = "";
        setTimeout(() => {
          _this.$refs["registForm"].clearValidate(["city", "county"]);
        }, 0);
        _this.cityArr = [];
        _this.cityArr.push({ id: "", name: "—— 市 ——" });
        _this.getCityData(provinceId, function(city) {
          city.forEach((item) => {
            _this.cityArr.push(item);
          });
        });
      }
    },
    changeCity(cityId) {
      let _this = this;
      if (cityId !== "") {
        _this.registForm.county = "";
        setTimeout(() => {
          _this.$refs["registForm"].clearValidate("county");
        }, 0);
        _this.countyArr = [];
        _this.countyArr.push({ id: "", name: "—— 县 ——" });
        _this.getCityData(cityId, function(county) {
          county.forEach((item) => {
            _this.countyArr.push(item);
          });
        });
      }
    },
    getCityData(selectId, okCBK) {
      let _this = this;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["cityData"]["method"],
          url: apiMap["cityData"]["url"],
          params: {
            locationId: selectId,
          },
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            okCBK(response.data.result.data);
          }
        });
    },
    openUserDeal() {
      this.useDealVisible = true;
    },
    openPrivacyDeal() {
      this.usePrivacyVisible = true;
    },
    setPassword(paramArr) {
      let _this = this;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["setPassword"]["method"],
          url: apiMap["setPassword"]["url"],
          data: paramArr.join("&"),
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.$alert("设置密码成功，请前往登录", {
              confirmButtonText: "确定",
              showClose: false,
              callback: (action) => {
                _this.$router.push("/login");
              },
            });
          } else {
            _this.$alert(response.data.result.data, {
              confirmButtonText: "确定",
              showClose: false,
            });
          }
        });
    },
    sdkListClick() {
      const { href } = this.$router.resolve({
        path: "/handlianSdkList",
      });
      window.open(href, "_blank");
    },
  },
};
</script>
<style scoped>
.register-wrapper {
  width: 1200px;
  height: 950px;
  margin: 0 auto;
}

.regitster-logo-wrap {
  padding: 115px 0 50px;
  justify-content: center;
}

.regitster-form-wrap {
  width: 1100px;
  height: 600px;
  margin: 0 auto;
  background-color: #fff;
}

.password-form-wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 1100px;
  height: 600px;
  margin: 0 auto;
  background-color: #fff;
}

.register-text {
  height: 150px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  line-height: 150px;
}

.register-form-container {
  width: 505px;
  margin: 0 auto;
}

.password-form-container {
  width: 505px;
  margin: 0 auto;
}

.address-tip {
  margin-left: 100px;
  margin-bottom: 5px;
}

.get-code-btn {
  margin-left: 10px;
}

.agreement-wrap {
  margin-bottom: 10px;
}

.agreement-link {
  margin: 0 6px;
  cursor: pointer;
  color: #1a70db;
}

.use-agreement-container {
  height: 600px;
  padding: 10px;
  font-size: 16px;
  line-height: 30px;
  overflow-y: auto;
}

.sub-content {
  padding-left: 30px;
}

.sub-content.p-item-content {
  padding-left: 0;
}

.agreement-indent {
  text-indent: 33px;
}

.inscribe-wrap {
  text-align: right;
}

.greement-title {
  line-height: 2rem;
  text-align: center;
}

.indent-text {
  text-indent: 2rem;
}

.protocol-date {
  text-align: right;
}

.sdk-list-link {
  color: #1a70db;
  cursor: pointer;
}
</style>
